import { render, staticRenderFns } from "./ManterAnoLetivoView.vue?vue&type=template&id=1866a2c4"
import script from "./ManterAnoLetivoView.vue?vue&type=script&lang=js"
export * from "./ManterAnoLetivoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports